import React, { useState } from 'react';
import {
  AppBar, Toolbar, IconButton, Menu, MenuItem, Button, Box, Typography, Avatar,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { goToDashboard } from '../commun/navigation';
import logo from '../../images/logo.png';
import './HeaderCommun.css';

const HeaderCommun = ({


  fallbackLetter,
  userRole,
  userName,
  navigation,
  userNavigation,
  addButtonLabel,
  addButtonHref,
  cagnotte,
  userAvatar
}) => {
  const location = useLocation();
   const navigate = useNavigate();
  const [navMenuAnchor, setNavMenuAnchor] = useState(null);
  const [navMenuIndex, setNavMenuIndex] = useState(null);
  const [userMenuAnchor, setUserMenuAnchor] = useState(null);
  const [mobileMenuAnchor, setMobileMenuAnchor] = useState(null);


    const handleLogoClick = () => {
  goToDashboard(navigate);
};
  const handleLogout = () => {
    localStorage.clear();
    navigate('/');
  };

  const handleNavMenuOpen = (e, index) => {
    setNavMenuAnchor(e.currentTarget);
    setNavMenuIndex(index);
  };

  const handleNavMenuClose = () => {
    setNavMenuAnchor(null);
    setNavMenuIndex(null);
  };

const renderCagnotte = () => {
  const entries = cagnotte ? Object.entries(cagnotte).filter(([_, val]) => val > 0) : [];

  if (userRole === 'recruteur' && entries.length === 0) {
    return (
      <Typography className="header-cagnotte-inline">
        Ma cagnotte&nbsp;: <span className="header-cagnotte-amount-inline">0 €</span>
      </Typography>
    );
  }

  if (entries.length > 0) {
    return (
      <Typography className="header-cagnotte-inline">
        Ma cagnotte&nbsp;:
        {entries.map(([dev, amount], idx) => (
          <span key={dev} className="header-cagnotte-amount-inline">
            {amount.toLocaleString()} {dev}{idx < entries.length - 1 ? ',' : ''}
          </span>
        ))}
      </Typography>
    );
  }

  return null;
};


  return (
    <AppBar position="static" color="default" elevation={1} className="header-appbar">
      <Toolbar className="header-toolbar">
      <Box
        className="header-logo-link"
        onClick={handleLogoClick}
        style={{ cursor: 'pointer' }}
      >
        <img src={logo} alt="Logo Cooptaleo" className="header-logo" />
      </Box>

        {/* Desktop Nav */}
        <Box className="header-nav-desktop">
          {navigation.map((item, i) =>
            item.children ? (
              <Box key={item.name} className="header-nav-parent">
                <Button
                  endIcon={navMenuAnchor && navMenuIndex === i ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                  onClick={(e) => handleNavMenuOpen(e, i)}
                  color="inherit"
                  className="header-nav-btn"
                >
                  {item.name}
                </Button>
                <Menu
                  anchorEl={navMenuAnchor}
                  open={Boolean(navMenuAnchor) && navMenuIndex === i}
                  onClose={handleNavMenuClose}
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                >
                  {item.children.map((child) => (
                    <MenuItem
                      key={child.name}
                      component={Link}
                      to={child.href}
                      onClick={handleNavMenuClose}
                    >
                      {child.name}
                    </MenuItem>
                  ))}
                </Menu>
              </Box>
            ) : (
              <Button
                key={item.name}
                component={Link}
                to={item.href}
                color={location.pathname === item.href ? 'primary' : 'inherit'}
                className="header-nav-btn"
              >
                {item.name}
              </Button>
            )
          )}
            {addButtonLabel && addButtonHref && (
  <Button
    variant="contained"
    component={Link}
    to={addButtonHref}
    className="header-add-btn"
    sx={{ marginLeft: 2 }}
  >
    {addButtonLabel}
  </Button>
)}
        </Box>

        {/* Mobile Nav */}
        <Box className="header-nav-mobile">
          <IconButton onClick={(e) => setMobileMenuAnchor(e.currentTarget)} color="inherit">
            <MenuIcon />
          </IconButton>
          <Menu
            anchorEl={mobileMenuAnchor}
            open={Boolean(mobileMenuAnchor)}
            onClose={() => setMobileMenuAnchor(null)}
          >
            {navigation.map((item) =>
              item.children ? (
                item.children.map((child) => (
                  <MenuItem key={child.name} component={Link} to={child.href} onClick={() => setMobileMenuAnchor(null)}>
                    {child.name}
                  </MenuItem>
                ))
              ) : (
                <MenuItem key={item.name} component={Link} to={item.href} onClick={() => setMobileMenuAnchor(null)}>
                  {item.name}
                </MenuItem>
              )
            )}
            {userName === 'Invité'
              ? [
                  <MenuItem key="signup" component={Link} to="/signup" onClick={() => setMobileMenuAnchor(null)}>
                    Inscription
                  </MenuItem>,
                  <MenuItem key="login" component={Link} to="/login" onClick={() => setMobileMenuAnchor(null)}>
                    Connexion
                  </MenuItem>,
                ]
              : userNavigation.map((item) =>
                  item.name === 'Se déconnecter' ? (
                    <MenuItem key={item.name} onClick={handleLogout}>{item.name}</MenuItem>
                  ) : (
                    <MenuItem key={item.name} component={Link} to={item.href} onClick={() => setMobileMenuAnchor(null)}>
                      {item.name}
                    </MenuItem>
                  )
                )}

          </Menu>
        </Box>

        {/* User Section */}
        <Box className="header-user-desktop">
          {userName === 'Invité' ? (
            <>
              {location.pathname !== '/signup' && (
                <Button component={Link} to="/signup" variant="outlined" className="header-user-btn">
                  Inscription
                </Button>
              )}
              {location.pathname !== '/login' && (
                <Button component={Link} to="/login" variant="contained" className="header-user-btn">
                  Connexion
                </Button>
              )}
            </>
          ) : (
            <>
              <Box>
                <Typography className="header-username">{userName}</Typography>
                {renderCagnotte()}
              </Box>
              <IconButton onClick={(e) => setUserMenuAnchor(e.currentTarget)}>
              <Avatar className="header-avatar" src={userAvatar} alt={userName}>
  {!userAvatar && fallbackLetter}
</Avatar>              </IconButton>
              <Menu
                anchorEl={userMenuAnchor}
                open={Boolean(userMenuAnchor)}
                onClose={() => setUserMenuAnchor(null)}
              >
                {userNavigation.map((item) =>
                  item.name === 'Se déconnecter' ? (
                    <MenuItem key={item.name} onClick={handleLogout}>{item.name}</MenuItem>
                  ) : (
                    <MenuItem key={item.name} component={Link} to={item.href} onClick={() => setUserMenuAnchor(null)}>
                      {item.name}
                    </MenuItem>
                  )
                )}
              </Menu>
            </>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default HeaderCommun;
